import {
  FETCH_DEVICE_IP_INSIGHT,
  FETCH_DEVICE_IP_INSIGHT_FAILURE,
  FETCH_DEVICE_IP_INSIGHT_SUCCESS,
  UPDATE_DEVICE_IP_INSIGHT,
  REMOVE_DEVICE_IP_INSIGHT,
  RESET_DEVICE_IP_INSIGHT,
} from '../../action/Device';

const initialState = {
  detailMap: { },
};
const DeviceIPAddressInsightReducer = (curState = initialState, action = { type: '', payload: '' }) => {
  let newState;
  switch (action.type) {
    case FETCH_DEVICE_IP_INSIGHT:
      newState = {
        ...curState,
        detailMap: {
          ...curState.detailMap,
          [action.payload._id]: {
            isLoading: true,
            data: {},
            error: '',
          },
        },
      };
      break;
    case FETCH_DEVICE_IP_INSIGHT_SUCCESS: {
      if (curState.detailMap[action.payload._id]) {
        newState = {
          ...curState,
          detailMap: {
            ...curState.detailMap,
            [action.payload._id]: {
              isLoading: false,
              data: action.payload.data,
              error: '',
              lastFetched: Date.now(),
            },
          },
        };
      } else {
        newState = curState;
      }
      break;
    }
    case FETCH_DEVICE_IP_INSIGHT_FAILURE: {
      if (curState.detailMap[action.payload._id]) {
        newState = {
          ...curState,
          detailMap: {
            ...curState.detailMap,
            [action.payload.id]: {
              ...curState.detailMap[action.payload._id],
              isLoading: false,
              error: action.payload.error,
              lastFetched: Date.now(),
            },
          },
        };
      } else {
        newState = curState;
      }

      break;
    }
    case UPDATE_DEVICE_IP_INSIGHT: {
      const { _id, data } = action.payload;
      if (curState.detailMap[_id]) {
        newState = {
          ...curState,
          detailMap: {
            ...curState.detailMap,
            [_id]: {
              ...curState.detailMap[_id],
              data: {
                ...curState.detailMap[_id].data,
                ...data,
              },
              lastFetched: Date.now(),
            },
          },
        };
      } else {
        newState = curState;
      }
      break;
    }
    case RESET_DEVICE_IP_INSIGHT: {
      newState = { ...initialState };
      break;
    }
    case REMOVE_DEVICE_IP_INSIGHT: {
      const { detailMap } = curState;
      if (detailMap[action.payload]) {
        delete detailMap[action.payload];
        newState = {
          detailMap: { ...detailMap },
        };
      } else {
        newState = curState;
      }
      break;
    }
    default:
      newState = curState;
  }

  return newState;
};

export default DeviceIPAddressInsightReducer;
